import { NewGoodsProposalModel } from "../vo/new-goods-proposal.model";

export class MasterInputModel {
  public allCoop = false;

  constructor(
    public proposalId = '',
    public masterInputId = '',
    public pCode = '',
    public itemCode = '',
    public janCode = '',
    public goodsName = '',
    public standardName = '',
    public mediumType = '',
    public classCode = '',
    public largeClassCode = '',
    public middleClassCode = '',
    public smallClassCode = '',
    public orderUnitType = '',
    public setQuantity = '',
    public standardSellingPrice = '',
    public special1SellingPrice = '',
    public special2SellingPrice = '',
    public standardCostPrice = '',
    public special1CostPrice = '',
    public special2CostPrice = '',
    public bundlePrice = '',
    public unitPriceDiv = '',
    public unitPriceCoefficient = '',
    public unitPriceUnit = '',
    public edlpDiv = '',
    public expirationDate = '',
    public bestBeforeDate = '',
    public setDiv = '',
    public caseSupplyDiv = '',
    public arrivalAreaDiv = '',
    public arrivalGoodsTemp = '',
    public arrivalAdminDays = '',
    public brandType = '',
    public ecologyDivList = [],
    public cycleTerm = '',
    public priceType = '',
    public markerPrice = '',
    public expandableCoop = {
      ibaraki: false,
      tochigi: false,
      gunma: false,
      chiba: false,
      saitama: false,
      tokyo: false,
      nagano: false,
      niigata: false
    },
    public packagePhotoNum = '',
    public packageDataNum = '',
    public peakPhotoNum = '',
    public peakDataNum = '',
    public cookingNecessaryPhotoNum = '',
    public cookingNecessaryDataNum = '',
    public cookingUnnecessaryPhotoNum = '',
    public cookingUnnecessaryDataNum = '',
    public materialPhotoNum = '',
    public materialDataNum = '',
    public backsidePhotoNum = '',
    public backsideDataNum = '',
    public goodsExplanation = '',
    public catchPhrase = '',
    public recommendComment = '',
    public usefulInfoEnclosure = '',
    public usefulInfoConfiguration = '',
    public usefulInfoOther = '',
    public usefulInfoSize = '',
    public handlingCaution = '',
    public markDiv = {
      markDiv1: '',
      markDiv2: '',
      markDiv3: '',
      markDiv4: '',
      markDiv5: '',
      markDiv6: '',
      markDiv7: '',
      markDiv8: '',
      markDiv9: '',
      markDiv10: '',
    },
    public consumeTaxRate = '',
    public alcoholPercentage = '',
    public fruitJuice = '',
    public sakeMeterValue = '',
    public body = '',
    public functionalOrFoshu = '',
    public liquorCode = '',
    public alcoholType = '',
    public containerForm = '',
    public applyTermStart = '',
    public applyTermEnd = '',
    public seasonConsumeDiv = false,
    public seasonConsumeTermStart = '',
    public seasonConsumeTermEnd = '',
    public stinkGoodsDiv = '',
    public listingGoodsName = '',
    public listingType = '',
    public listingContentsQuantity = '',
    public listingSize = '',
    public listingSizeCm = '',
    public listingNumber = '',
    public listingColor = '',
    public pieceSizeLength = '',
    public caseSizeLength = '',
    public pieceSizeWidth = '',
    public caseSizeWidth = '',
    public pieceSizeHeight = '',
    public caseSizeHeight = '',
    public pieceWeight = '',
    public caseWeight = '',
    public ingredientInfo = '',
    public ingredientDisp = '',
    public relationPCodeOld = '',
    public specialOrderType = '',
    public stockType = '',
    public pdPilingUpDays = '',
    public factoryAddress1 = '',
    public factoryAddress2 = '',
    public fcmcFee = '',
    public goodsBaseAdmitStatus = '',
  ) {
    this.allCoop = Object.values(this.expandableCoop).every(coop => coop);
  }

  static fromNewGoodsProposal(newGoodsProposal: NewGoodsProposalModel, pCode: string, itemCode: string) {
    return new MasterInputModel(
      newGoodsProposal.proposalId,
      '',
      pCode,
      itemCode,
      newGoodsProposal.janCode,
      newGoodsProposal.goodsName,
      newGoodsProposal.standardName,
      '',
      newGoodsProposal.classCode,
      '',
      '',
      '',
      '',
      '',
      newGoodsProposal.standardSellingPrice,
      newGoodsProposal.special1SellingPrice,
      newGoodsProposal.special2SellingPrice,
      newGoodsProposal.standardCostPrice,
      newGoodsProposal.special1CostPrice,
      newGoodsProposal.special2CostPrice,
      '',
      '',
      '',
      '',
      '',
      newGoodsProposal.expirationDate,
      newGoodsProposal.bestBeforeDate,
      '',
      '',
      '',
      '',
      '',
      '',
      [],
      '',
      '',
      '',
      newGoodsProposal.expandableCoop
    );
  }
}